// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4329d1e3","453":"1d549cba","455":"b1ea5da9","977":"68a1bbd0"}[chunkId] + ".chunk.js";
};